import noop from 'lodash/noop.js';
import { useEffect } from 'react';
import { useInteractionFn } from './useInteractionFn.js';
/**
 * Same as `useInterval` but uses interaction avoidance. This will try to
 * cancel the previous interaction each interval, and will cancel and clean up
 * the effect. This is done in case interaction handler doesn't fire until
 * after the next interval or unmount, due to excessive interaction. This
 * scenario seems pretty unlikely, but it's straightforward and avoids should
 * avoid any weird / rare behavior.
 */
export const useInteractionInterval = (fn, delay) => {
    const callbackField = useInteractionFn(fn);
    useEffect(() => {
        let cancel = noop;
        if (delay != null) {
            const id = window.setInterval(() => {
                cancel();
                const ret = callbackField();
                cancel = ret.cancel;
            }, delay);
            return () => {
                cancel();
                window.clearInterval(id);
            };
        }
    }, [delay]);
};
//# sourceMappingURL=useInteractionInterval.js.map